import { FC } from 'react'

type Props = {
  className?: string
}

const SpacesIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 22 22"
      fill="currentColor"
      width="1em"
      height="1em"
      className={className}
    >
      <path d="m11 1 .447-.894a1 1 0 0 0-.894 0L11 1ZM1 6l-.447-.894a1 1 0 0 0 0 1.788L1 6Zm10 5-.447.894a1 1 0 0 0 .894 0L11 11Zm10-5 .447.894a1 1 0 0 0 0-1.788L21 6ZM1.447 15.106a1 1 0 1 0-.894 1.788l.894-1.788ZM11 21l-.447.894a1 1 0 0 0 .894 0L11 21Zm10.447-4.106a1 1 0 1 0-.894-1.788l.894 1.788Zm-20-6.788a1 1 0 1 0-.894 1.788l.894-1.788ZM11 16l-.447.894a1 1 0 0 0 .894 0L11 16Zm10.447-4.106a1 1 0 1 0-.894-1.788l.894 1.788ZM10.553.106l-10 5 .894 1.788 10-5-.894-1.788Zm-10 6.788 10 5 .894-1.788-10-5-.894 1.788Zm10.894 5 10-5-.894-1.788-10 5 .894 1.788Zm10-6.788-10-5-.894 1.788 10 5 .894-1.788ZM.553 16.894l10 5 .894-1.788-10-5-.894 1.788Zm10.894 5 10-5-.894-1.788-10 5 .894 1.788Zm-10.894-10 10 5 .894-1.788-10-5-.894 1.788Zm10.894 5 10-5-.894-1.788-10 5 .894 1.788Z" />
    </svg>
  )
}

export default SpacesIcon
